
const state = {
    //视图 测量点数据
    data: new Map(),
};
const mutations = {
    /**
     * 设置视图数据
     * @param {*} state 
     * @param {*} param {viewId,data}
     */
    SET_VIEW_TREE_DATA(state, param) {
        if (param) {
            const key = param.viewId
            state.data.set(key, param.data)
        }
    },
};
const actions = {
};
const getters = {
    GET_VIEW_TREE_DATA_FOR_VIEWID: (state) => (viewId) => {
        if (viewId) {
            return state.data.get(viewId)
        }
        else {
            return null;
        }
    }
};

// 不要忘记把state, mutations等暴露出去。
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}